// let loaded = false;
// document.addEventListener("DOMContentLoaded", function () {
//   if (!loaded) {
//     const containerCollectons = Array.from(document.querySelectorAll(".Container__Collections"));

//     for (const collection of containerCollectons) {
//       const dots = Array.from(collection.querySelectorAll(".dot"));
//       let carousel = collection.querySelector(".Carousel");
//       console.log(dots);

//       for (let dot of dots) {
//         dot.addEventListener("click", (e) => {
//           console.log(collection);
//           let dotIndex = dot.getAttribute("data-index");
//           collection.scrollTo(collection.querySelector(`["data-product-index='${dotIndex}']"`), 0);
//         });
//       }
//     }
//   }
// });

function dotsScroll(index) {
  console.log(this.event.target);
}
